import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { Benefit } from "../models/benefit";
import { FilterBenefitCatalog } from "../models/filters/filter-benefit-catalog";

@Injectable({
  providedIn: 'root'
})
export class BenefitCatalogService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/benefitsCatalog'; 

  findAllPageableBenefitCatalog(filterBenefitCatalog: FilterBenefitCatalog, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterBenefitCatalog);
  }

  findBenefitCatalogById(id: number): Observable<Benefit> {
    return this.http.get<Benefit>(`${this.url}/${id}`);
  }

  createBenefitCatalog(benefit: Benefit): Observable<Benefit>{
    return this.http.post<Benefit>(this.url, benefit);
  }

  updateBenefitCatalog(benefit: Benefit): Observable<Benefit>{
    return this.http.put<Benefit>(`${this.url}/${benefit.id}`, benefit);
  }

}